/**
 * LD.CLPBP.Public.Service
 * No descripton provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

'use strict';
import * as models from './models';

export interface LDCLPBPPublicApiModelsPricingMortgagePricingException {
    

    exceptionType?: LDCLPBPPublicApiModelsPricingMortgagePricingException.ExceptionTypeEnum;

    status?: LDCLPBPPublicApiModelsPricingMortgagePricingException.StatusEnum;

    reason?: LDCLPBPPublicApiModelsPricingMortgagePricingException.ReasonEnum;

    points?: number;

    dollarAmt?: number;

    notes?: string;

    competitorName?: LDCLPBPPublicApiModelsPricingMortgagePricingException.CompetitorNameEnum;

    competitorQuoteDate?: Date;

    competitorRate?: number;

    competitorPoints?: number;

    competitorCosts?: number;

    responsibleParty?: LDCLPBPPublicApiModelsPricingMortgagePricingException.ResponsiblePartyEnum;

    previousApproval?: boolean;

    requestedOn?: Date;

    requestedBy?: string;

    requestedById?: string;

    verifiedOn?: Date;

    verifiedBy?: string;

    verifiedById?: string;

    decisionOn?: Date;

    decisionBy?: string;

    decisionById?: string;

    branchManagerEmailAddresses?: Array<string>;

    emailCopyRecipients?: Array<string>;
}
export namespace LDCLPBPPublicApiModelsPricingMortgagePricingException {

    export enum ExceptionTypeEnum { 
        General = <any> 'General',
        PricingConcession = <any> 'PricingConcession',
        MatchOrBeat = <any> 'MatchOrBeat',
        ExtensionWaiver = <any> 'ExtensionWaiver',
    }

    export enum StatusEnum { 
        Unknown = <any> 'Unknown',
        Requested = <any> 'Requested',
        Approved = <any> 'Approved',
        Denied = <any> 'Denied',
        Cancelled = <any> 'Cancelled',
        Unlocked = <any> 'Unlocked',
        Verified = <any> 'Verified',
    }

    export enum ReasonEnum { 
        Unknown = <any> 'Unknown',
        ExtensionWaiver7 = <any> 'ExtensionWaiver7',
        ExtensionWaiver15 = <any> 'ExtensionWaiver15',
        ExtensionWaiver30 = <any> 'ExtensionWaiver30',
        ExtensionWaiver45 = <any> 'ExtensionWaiver45',
        RelockWaiver15 = <any> 'RelockWaiver15',
        RelockWaiver30 = <any> 'RelockWaiver30',
        RelockWaiver45 = <any> 'RelockWaiver45',
        ProgramChangeWaiver = <any> 'ProgramChangeWaiver',
        ReworkWaiver = <any> 'ReworkWaiver',
        InternalPricingError = <any> 'InternalPricingError',
        EmpowerIssue = <any> 'EmpowerIssue',
        MatchOrBeat = <any> 'MatchOrBeat',
        PricingConcession = <any> 'PricingConcession',
        RepeatBorrower = <any> 'RepeatBorrower',
        FamilyFriendRefer = <any> 'FamilyFriendRefer',
        PricingSpecial = <any> 'PricingSpecial',
        WorstCaseWaiver = <any> 'WorstCaseWaiver',
        Correction = <any> 'Correction',
        SecondaryAdjustment = <any> 'SecondaryAdjustment',
        FloatDown = <any> 'FloatDown',
        TexasCashOut = <any> 'TexasCashOut',
        HPML = <any> 'HPML',
        QM = <any> 'QM',
        ImpairedAsset = <any> 'ImpairedAsset',
        SecondarySubsidy = <any> 'SecondarySubsidy',
        RateRenegotiation = <any> 'RateRenegotiation',
        PriceDiscrepency = <any> 'PriceDiscrepency',
        OperationError = <any> 'OperationError',
        FlexibleCloseOfEscrowDate = <any> 'FlexibleCloseOfEscrowDate',
        MarketCompetitiveness = <any> 'MarketCompetitiveness',
        BranchSubsidy = <any> 'BranchSubsidy',
        ExtensionWaiver21 = <any> 'ExtensionWaiver21',
        ShortToClose = <any> 'ShortToClose',
        NeedToWaiveLLPAS = <any> 'NeedToWaiveLLPAS',
        Other = <any> 'Other',
    }

    export enum CompetitorNameEnum { 
        Unknown = <any> 'Unknown',
        Quicken = <any> 'Quicken',
        Amerisave = <any> 'Amerisave',
        WellsFargo = <any> 'WellsFargo',
        Provident = <any> 'Provident',
        Discover = <any> 'Discover',
        BankOfAmerica = <any> 'BankOfAmerica',
        CitiMortgage = <any> 'CitiMortgage',
        Chase = <any> 'Chase',
        NavyFederal = <any> 'NavyFederal',
        NationstarGreenlight = <any> 'NationstarGreenlight',
        LocalBroker = <any> 'LocalBroker',
        RoundPoint = <any> 'RoundPoint',
        Other = <any> 'Other',
    }

    export enum ResponsiblePartyEnum { 
        Unknown = <any> 'Unknown',
        CustomerDelay = <any> 'CustomerDelay',
        Appraisal = <any> 'Appraisal',
        Underwriting = <any> 'Underwriting',
        Processing = <any> 'Processing',
        Sales = <any> 'Sales',
        Subordination = <any> 'Subordination',
        TitleCompany = <any> 'TitleCompany',
        TitleIssues = <any> 'TitleIssues',
        PropertyRepairs = <any> 'PropertyRepairs',
        Payoff = <any> 'Payoff',
        QCDelay = <any> 'QCDelay',
        DocsOrderedNotOut = <any> 'DocsOrderedNotOut',
        Other = <any> 'Other',
    }
}
